// Mixins
import { userMixins } from '@/app/mixins/modules/user-mixins.js';

// Third party libraries
import { differenceInCalendarYears, differenceInCalendarMonths, differenceInCalendarWeeks } from 'date-fns';
import EventBus from '@/app/bus/event-bus';

export default {
	name: 'SwitchPet',
	mixins: [
		userMixins
	],
	computed:{
		isMobile() {
			return screen.width <= 425
        },
	},
	methods: {
		addAnotherPet() {
			this.$emit('addAnotherPet');
		},
		switchActivePet(pet) {

			if (this.getActivePet.id !== pet.id) {
				this.$store.commit('setActivePet', pet);
				EventBus.$emit('petSwitched');
			}
		},
		computeAge(date) {
			const birthDate = new Date(date);
			const currentDate = new Date();

			// Compute months difference
			let age = differenceInCalendarMonths(currentDate, birthDate);

			if (age <= 11) {
				let weekDiff = differenceInCalendarWeeks(currentDate, birthDate);

				if (age === 0 || weekDiff <= 3) {
					// Compute weeks difference
					age = weekDiff;

					if (age === 0) {
						return `Less than a week old`;
					}
					return `${age} week${age !== 1? 's' : ''} old`;
				}
				return `${age} month${age !== 1? 's' : ''} old`;
			}

			// Compute Year difference
			age = differenceInCalendarYears(currentDate, birthDate);
			return `${age} year${age !== 1? 's' : ''} old`;
		}
	}
}